import Subjects from './views/subjects/subjects.vue';
import Purchased from './views/purchased/purchased.vue';
import Contents from './views/contents/contents.vue';
import TemplatesView from './views/templates/templates.view.vue';

import { ROLES } from '@/auth/enums/auth.enum';
import { RolesNotAllowGuard } from '@/auth/guards/role-not-allow.guard';
import { ALL_CONTENT_ROUTES_DEFAULT } from '../../values/my-content.values';
import { AuthProvider } from '@/auth/providers/auth.provider';

export const ALL_CONTENT_ROUTES = {
  ROOT: {
    NAME: 'private.myContent.all',
  },
  SUBJECTS: {
    NAME: 'private.myContent.all.subjects',
    PATH: 'subjects'
  },
  PURCHASED: {
    NAME: 'private.myContent.all.purchased',
    PATH: 'purchased'
  },
  CONTENTS: {
    NAME: 'private.myContent.all.contents',
    PATH: ':page/list'
  },
  TEMPLATES: {
    NAME: 'private.myContent.all.templates',
    PATH: 'templates'
  }
};

export const allContentRoutes = [
  {
    path: '/',
    name: 'private.myContent.all',
    redirect: to => {
      const userRoles = AuthProvider.getRolesFromAccessToken();
      const routeDefaultFound = ALL_CONTENT_ROUTES_DEFAULT.find(
        item => item.forRoles.some(role => userRoles.includes(role))
      );

      if (routeDefaultFound) {
        return { name: routeDefaultFound.defaultRoute };
      }

      return { name: ALL_CONTENT_ROUTES.SUBJECTS.NAME };
    }
  },
  { 
    name: ALL_CONTENT_ROUTES.SUBJECTS.NAME,
    path: ALL_CONTENT_ROUTES.SUBJECTS.PATH,
    component: Subjects,
    beforeEnter: RolesNotAllowGuard.bind({ 
      rolesNotAllow: [
        ROLES.EDUAC_AUTHOR,
        ROLES.EDUAC_STUDENT,
        ROLES.EDUAC_SUBSTITUTE_TEACHER
      ],
      name: ALL_CONTENT_ROUTES.ROOT.NAME
    }),
  },
  { 
    name: ALL_CONTENT_ROUTES.PURCHASED.NAME,
    path: ALL_CONTENT_ROUTES.PURCHASED.PATH,
    component: Purchased,
    beforeEnter: RolesNotAllowGuard.bind({ 
      rolesNotAllow: [
        ROLES.EDUAC_AUTHOR,
      ],
      name: ALL_CONTENT_ROUTES.ROOT.NAME
    }),
  },
  { 
    name: ALL_CONTENT_ROUTES.CONTENTS.NAME,
    path: ALL_CONTENT_ROUTES.CONTENTS.PATH,
    component: Contents
  },
  { 
    name: ALL_CONTENT_ROUTES.TEMPLATES.NAME,
    path: ALL_CONTENT_ROUTES.TEMPLATES.PATH,
    component: TemplatesView,
    beforeEnter: RolesNotAllowGuard.bind({ 
      rolesNotAllow: [
        ROLES.EDUAC_STUDENT,
        ROLES.EDUAC_SUBSTITUTE_TEACHER
      ],
      name: ALL_CONTENT_ROUTES.ROOT.NAME 
    }),
  },
];